import axios from '../../../core/services/axios';

export const getEvents = (params, cancelToken) => axios.get('/api/events', { params, cancelToken });
export const deleteEvent = (id, data) => axios.delete(`/api/events/${id}`, { data });
export const duplicateEvent = (id) => axios.post(`/api/events/${id}/duplicate`);
export const createEvent = (data) => axios.post('/api/events', data);
export const updateEvent = (id, data) => axios.put(`/api/events/${id}`, data);
